import moment from 'moment';

interface UI {
    error: string;
    connecting: string;
    sending: string;
    selectQueue: string;
    notDelivered: string;
    noAgentsOnline: string;
    placeholder: string;
    newSession: string;
}

const langs: Record<string, UI> = {
    'ar': {
        error: 'نعتذر لقد حصل خطأ ما.',
        connecting: 'جاري الاتصال.',
        sending: 'جاري الارسال.',
        selectQueue: 'الرجاء اختيار موضوع',
        notDelivered: 'لم يتم الارسال',
        noAgentsOnline: 'لا يوجد موظفين حاليا',
        placeholder: 'اكتب هنا',
        newSession: 'مقطع جديد',
    },
    'en': {
        error: 'Something went wrong, sorry',
        connecting: 'Connecting...',
        sending: 'Sending...',
        selectQueue: 'Please choose a topic',
        notDelivered: 'Not delivered',
        noAgentsOnline: 'No agents online',
        placeholder: 'write here...',
        newSession: 'New session',
    },
    'hu': {
        error: 'Elnézést, valalmi hiba történt',
        connecting: 'Kapcsolódás...',
        sending: 'Küldés...',
        selectQueue: 'Kérem válasszon az alábbi témák közül',
        notDelivered: 'Sikertelen kézbesítés',
        noAgentsOnline: 'Nincsenek elérhető operátorok',
        placeholder: 'ide írjon...',
        newSession: 'Új beszélgetés',
    },
    'de': {
        error: 'Etwas ist schief gegangen, sorry',
        connecting: 'Verbinde...',
        sending: 'Senden...',
        selectQueue: 'Bitte wählen Sie ein Thema',
        notDelivered: 'Nicht zugestellt',
        noAgentsOnline: 'Kein Agent online',
        placeholder: 'Schreibe hier',
        newSession: 'Neue Sitzung',
    },
    'ru': {
        error: 'Что-то пошло не так, извините',
        connecting: 'Соединение...',
        sending: 'Отправка...',
        selectQueue: 'Пожалуйста, выберите тему',
        notDelivered: 'Не доставлено',
        noAgentsOnline: 'Нет доступных сотрудников',
        placeholder: 'Введите текст...',
        newSession: 'Новый чат',
    },
    'pl': {
        error: 'Coś poszło nie tak, przepraszamy',
        connecting: 'Łączenie...',
        sending: 'Wysyłanie...',
        selectQueue: 'Wybierz temat',
        notDelivered: 'Nie dostarczono',
        noAgentsOnline: 'Brak agentów online',
        placeholder: 'Napisz tutaj',
        newSession: 'Nowa sesja',
    },
    'hy-am': {
        error: 'սխալ',
        connecting: 'կապի հաստատում',
        sending: 'ուղարկվում է',
        selectQueue: 'ընտրել հերթը',
        notDelivered: 'ստացված չէ',
        noAgentsOnline: 'հասանելի օպերատորը չկա',
        placeholder: 'Մուտքագրեք Ձեր նամակը',
        newSession: 'Նոր հաղորդագրություն',
    },
};

const langMapping: { [key: string]: string } = {
    hy: 'hy-am',
};

const rtlLanguages = [
    'ar',
];

export function getLang(lang: string) {
    const code = lang.substring(0, 2);
    let bundle = 'en';

    if (langs[code]) {
        bundle = code;
    } else if (langMapping[code]) {
        bundle = langMapping[code];
    }

    momentLocale(bundle);
    return langs[bundle];
}

let momentLocalised = false;

function momentLocale(code: string) {
    if (process.env.NODE_ENV === 'test') {
        moment.locale(code);
        return;
    }
    if (code === 'en' || momentLocalised) {
        return;
    }
    momentLocalised = true;
    // @ts-ignore
    window.moment = moment;
    const script = document.createElement('script');
    script.onload = function () {
        moment.locale(code);
    };
    script.src = `locale/${code}.min.js`;
    document.body.appendChild(script);
}

export function getTextDirection(lang: string) {
    return rtlLanguages.indexOf(lang) >= 0 ? 'rtl' : 'auto';
}
